import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getErrorMessage } from "../services/utils";
import { BASE_URL } from "../envVariables";

interface Firebase {
  apiKey: string;
  authDomain: string;
  projectId: string;
}

interface Endpoints {
  "billing-ng": string;
  metrics: string;
  metering: string;
  console: string;
  registry: string;
  browser: string;
  hub: string;
  audit: string;
  logs: string;
  grafana: string;
  "terraform-exporter": string;
  "k8s-crd-exporter": string;
  byok: string;
}

interface DiscoveryState {
  requested: boolean;
  requesting: boolean;
  error: string;
  firebase: Firebase;
  endpoints: Endpoints;
}

const initialState: DiscoveryState = {
  requested: false,
  requesting: false,
  error: "",
  firebase: {} as any,
  endpoints: {} as any,
};

export const fetchDiscovery = createAsyncThunk("discovery/fetch", async (_, { rejectWithValue }) => {
  try {
    const res = await fetch(`${BASE_URL}/discovery`);
    const resJson = await res.json();
    return resJson as {
      firebase: Firebase;
      endpoints: Endpoints;
    };
  } catch (e) {
    return rejectWithValue(getErrorMessage(e));
  }
});

export const discoverySlice = createSlice({
  name: "discovery",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle fetchDiscovery states
      .addCase(fetchDiscovery.pending, (state) => {
        state.error = "";
        state.requesting = true;
      })
      .addCase(fetchDiscovery.fulfilled, (state, action) => {
        state.error = "";
        state.requesting = false;
        state.requested = true;
        state.firebase = action.payload.firebase;
        state.endpoints = action.payload.endpoints;
      })
      .addCase(fetchDiscovery.rejected, (state, action) => {
        state.error = action.error.message || "Failed to fetch discovery";
        state.requesting = false;
      });
  },
});

export const discoveryReducer = discoverySlice.reducer;
